import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { getVideoTimeAsHHMMSS } from '../../utils/utils';

interface Props {
	className?: string
	elapsed: number
	duration: number
	mediaId?: number
	position?: number
}

const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);

export default function MediaVideoTimer(props: Props) {
	const { duration, elapsed } = props;

	const [timerString, setTimerString] = useState('0:00 / 0:00');

	const getMinWidth = (seconds: number) => {
		/* If the time changed from 9:59 to 10:00 the video track bar would
		shrink, because the timer grew from the extra digit, so set a minWidth */
		let charCount;
		if (seconds < 600) {
			charCount = 6; // max width - X:XX / X:XX (6chars)
		} else if (seconds < 3600) {
			charCount = 8; // max width - XX:XX / XX:XX (8chars)
		} else if (seconds < 36000) {
			charCount = 10; // X:XX:XX / X:XX:XX (10chars)
		} else {
			charCount = 12; // XX:XX:XX / XX:XX:XX (12chars)
		}

		// there are 5 symbols (:/: and 2 spaces)
		const totalWidth = (charCount * 11) + (5 * 4);
		return totalWidth;
	};

	useEffect(() => {
		// if elapsed is negative, set to 0, if more than duration, set to duration
		const rElapsed = clamp(elapsed, 0, duration);
		const currentTime = getVideoTimeAsHHMMSS(rElapsed);
		const totalDuration = getVideoTimeAsHHMMSS(duration);
		setTimerString(`${currentTime} / ${totalDuration}`);
	}, [elapsed, duration]);

	return (
		<div
			className={'white-space-nowrap font-weight-bold padding-right-medium margin-left-xsmall'}
			style={{
				minWidth: `${getMinWidth(duration)}px`,
				textAlign: 'right',
				fontFamily: 'Roboto',
			}}
		>
			<>{timerString}</>
		</div>
	);
}
